import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[300],
    display: 'flex',
  },
}));
